/**
 * Hook per accedere ai colori delle azioni standardizzati
 * Utilizza i colori definiti nel design system
 */

import { colors } from '../tokens/colors';

export interface ActionColorProps {
  color: string;
  hoverBackground: string;
  hoverColor: string;
}

export const useActionColors = () => {
  return {
    view: {
      color: colors.semantic.actions.view.color,
      hoverBackground: colors.semantic.actions.view.hoverBackground,
      hoverColor: colors.semantic.actions.view.hoverColor,
    },
    edit: {
      color: colors.semantic.actions.edit.color,
      hoverBackground: colors.semantic.actions.edit.hoverBackground,
      hoverColor: colors.semantic.actions.edit.hoverColor,
    },
    delete: {
      color: colors.semantic.actions.delete.color,
      hoverBackground: colors.semantic.actions.delete.hoverBackground,
      hoverColor: colors.semantic.actions.delete.hoverColor,
    },
  };
};

export default useActionColors;
